/*eslint no-unused-vars: ["error", { "args": "none" }]*/

import {
  CREATE_PURCHASE,
  FETCH_DOWNLOAD_URL,
  FETCH_PAYMENT,
  SET_PAYMENT,
  VERIFY_TOKEN,
  FETCH_NAIC_CODES,
  SET_NAIC_CODES,
  FETCH_UNDERWRITINGS,
  SET_UNDERWRITINGS,
  DOWNLOAD_RECEIPT,
  UPDATE_UNDERWRITING,
  SET_UPDATE_UNDERWRITING,
  FETCH_INSURANCE_RECEIPT_DOWNLOAD_URL,
  UPDATE_PAYMENT,
  SET_UPDATE_PAYMENT
} from "../types";
import { api } from "../../utils";

export default {
  state: {
    naicCodes: [],
    payment: null,
    underWritings: [],
    underWritingsMeta: {},
  },
  getters: {},
  mutations: {
    [SET_PAYMENT]:(state, payload) => {
      state.payment = payload.payment;
    },
    [SET_NAIC_CODES]:(state, payload) => {
      state.naicCodes = payload.naicCodes;
    },
    [SET_UNDERWRITINGS]: (state, payload) => {
      state.underWritings = payload.underWritings;
      state.underWritingsMeta = payload.meta;
    },
    [SET_UPDATE_UNDERWRITING]: (state, payload) => {
      let index = state.underWritings.findIndex(
        (instance) => instance.id === payload.underwriting.id
      );
      state.underWritings.splice(index, 1, payload.underwriting);
      state.payment = payload.underwriting;
    },
    [SET_UPDATE_PAYMENT]: (state, payload) => {
      let index = state.underWritings.findIndex(
        instance => instance.id === payload.payment.id
      );
      if (index > -1) {
        state.underWritings.splice(index, 1, payload.payment);
      }
    }
  },
  actions: {
    [CREATE_PURCHASE]: ({ dispatch, commit }, payload) => {
      return api("/store", "POST", payload.data, false).then(res => {
        const payment = res.data;
        commit({
          type: SET_PAYMENT,
          payment
        })
        return res;
      });
    },
    [FETCH_DOWNLOAD_URL]: ({ dispatch, commit }, payload) => {
      return api(`/payment/get-url/${payload.id}`, "POST", {}, false).then(res => {
        return res;
      });
    },
    [FETCH_INSURANCE_RECEIPT_DOWNLOAD_URL]: ({ dispatch, commit }, payload) => {
      return api(`/payment/get-insurance-url/${payload.id}`, "POST", {}, false).then(res => {
        return res;
      });
    },
    [FETCH_PAYMENT]: ({ dispatch, commit }, payload) => {
      return api(`/payment/${payload.id}`, "GET", {}, false).then(res => {
        const payment = res.data;
        commit({
          type: SET_PAYMENT,
          payment
        });
      });
    },
    [UPDATE_PAYMENT]: ({ dispatch, commit }, payload) => {
      return api(`/payment/${payload.id}`, "PUT", payload.data).then(res => {
        const payment = res.data;
        commit({
          type: SET_UPDATE_PAYMENT,
          payment
        });
      });
    },
    [FETCH_NAIC_CODES]: ({ dispatch, commit }, payload) => {
      return api(`/naic-codes`, "GET", {}, false).then(res => {
        const naicCodes = res.data;
        commit({
          type: SET_NAIC_CODES,
          naicCodes
        });
      });
    },
    [VERIFY_TOKEN]: ({ dispatch, commit }, payload) => {
      return api(`/verify-retoken`, "POST", payload, false).then(res => {
        return res;
      });
    },
    [FETCH_UNDERWRITINGS]: ({ dispatch, commit }, payload) => {
      const { limit, offset, query = "", sort = "" } = payload;
      let param = `?query=${query}`;
      if (limit && offset != null) {
        param = param + `&limit=${limit}&offset=${offset}`;
      }
      if (sort && payload.order) {
        const order = payload.order == "ascending" ? "ASC" : "DESC";
        param = param + `&sort=${sort}&order=${order}`;
      }
      return api(`/underwritings${param}`).then(res => {
        const { data: underWritings, meta } = res;
        commit({
          type: SET_UNDERWRITINGS,
          underWritings,
          meta
        });
      });
    },
    [DOWNLOAD_RECEIPT]: ({ dispatch, commit }, payload) => {
      let param = "";
      if (payload.dashboard) {
        param += `?dashboard=true`;
      }
      return api(`/payment/get-url/${payload.id}${param}`, "POST", {}).then(
        (res) => {
          return res;
        }
      );
    },
    [UPDATE_UNDERWRITING]: ({ dispatch, commit }, payload) => {
      return api(`/underwriting/${payload.id}/mark-complete`, "POST", payload.data).then(
        (res) => {
          let underwriting = res.data;
          commit({
            type: SET_UPDATE_UNDERWRITING,
            underwriting
          })
        }
      );
    },
  }
}